<template>
  <div class="uupay-container">
    

    <!-- 首屏 banner 区域 -->
    <UUPayBanner>
      <template v-slot:title>
        <div class="home1-img"><img src="@/assets/uupay/images/uu.png"></div> 
        <div class="banner-title-uu">秒過數</div>
      </template>
      <template v-slot:subtitle>
        輕鬆對接收款
      </template>
      <template v-slot:info>
        簡單 安全 迅速 / 0機價全面提升業務
      </template>
    </UUPayBanner>

    <!-- 支付方式图标区域 -->
    <UUPayMethod />

    <!-- 功能列表 + 示例图区域 -->
    <UUPayHomeFeature />

    <!-- Z世代智能付款方案标题区域 -->
    <section class="section-title">
      <div class="container d-flex justify-content-center">
        <img src="@/assets/uupay/images/z_pay_case.png" alt="feature-img" class="img-fluid z-pay-case">
      </div>
    </section>

    <!-- 功能模块区域（多行多列） -->
    <section class="modules-section">
      <div class="container modules-section-container">
        <!-- <div class="row">
          <div class="col-md-4" v-for="(module, index) in modules" :key="index">
            <el-card class="module-card" :body-style="{ padding: '0px' }">
              <img src="@/assets/demo.png" alt="module-img" class="img-fluid">
              <div class="card-content">
                <h5 class="card-title">{{ module.title }}</h5>
                <p class="card-text">{{ module.description }}</p>
              </div>
            </el-card>
          </div>
        </div> -->
        <div class="row content-row">
          <div class="col-md-6">
            <div class="content">
              <div class="pos-content">
                <div class="title">POS收款機</div>
                <div class="subtitle">0幾價增長業務</div>
              </div>
              <div class="pos-img">
                <img src="@/assets/uupay/images/pos_pay_machine.png" alt="pos" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="content">
              <div class="pos-content">
                <div class="title">收款連結</div>
                <div class="subtitle">隨時隨地  一健付款</div>
              </div>
              <div class="pos-img">
                <img src="@/assets/uupay/images/pay_connect.png" alt="pos" class="img-fluid">
              </div>
            </div>
          </div>
        </div>
        <div class="content-row" style="margin: 0 15px">
          <div class="content d-flex justify-content-between">
            <div>
              <div class="pos-content">
                <div class="title">支付網關</div>
                <div class="subtitle">開拓你的網上業務</div>
              </div>
              <div class="pos-img">
                <img src="@/assets/uupay/images/paygateway.png" alt="pos" class="img-fluid">
              </div>
            </div>
            <div class="d-flex align-items-end">
              <img src="@/assets/uupay/images/payment_detail.png" alt="pos" class="img-fluid">
            </div>
          </div>
        </div>
        <div class="row content-row">
          <div class="col-md-6">
            <div class="content">
              <div class="pos-content">
                <div class="title">二維碼支付</div>
                <div class="subtitle">靈活 低成本的收款方式</div>
              </div>
              <div class="pos-img">
                <img src="@/assets/uupay/images/pos_qrcode.png" alt="pos" class="img-fluid">
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="content">
              <div class="pos-content">
                <div class="title">2合一收款機</div>
                <div class="subtitle">下單收款一機辦妥</div>
              </div>
              <div class="pos-img">
                <img src="@/assets/uupay/images/two_in_one_pos.png" alt="pos" class="img-fluid">
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-7">
            <div class="content">
              <div class="pos-content">
                <div class="title">後台服務</div>
                <div class="subtitle">隨時支持你的支付款服務</div>
              </div>
              <div class="d-flex align-items-end justify-content-end" >
                <img src="@/assets/uupay/images/order_list.png" alt="pos" class="img-fluid" style="width: 456px;">
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="content">
              <div class="pos-content">
                <div class="title">全面賬通</div>
                <div class="subtitle">一個帳戶多種渠道</div>
              </div>
              <div class="pos-img">
                <img src="@/assets/uupay/images/all_channel_pay.png" alt="pos" class="img-fluid">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 合作商家区域 -->
    <UUPayMerchant />

    <!-- 底部 banner 区域 -->
    <UUPayBannerContact :info="['收付無界 系統無縫', 'UUPay 為你推動業務']" />

    <!-- 常见问题区域 -->
    <UUPayFaqs />

  </div>
</template>

<script>
import UUPayHomeFeature from "@/components/uupayHomeFeature";
import UUPayBannerContact from "@/components/uupayBannerContact";
import UUPayFaqs from "@/components/uupayFaqs";
import UUPayMethod from "@/components/uupayMethod";
import UUPayMerchant from "@/components/uupayMerchant";
import UUPayBanner from "@/components/uupayBanner";

export default {
  name: 'UUPayHome',
  components: {
    UUPayHomeFeature,
    UUPayBannerContact,
    UUPayFaqs,
    UUPayMethod,
    UUPayMerchant,
    UUPayBanner
  },
  data() {
    return {
      
    };
  },
  methods: {

  }
};
</script>

<style scoped>
.uupay-container {
  color: #21042E;
  font-weight: 400;
}




.z-pay-case {
  width: 80%;
}

.modules-section {
  margin: 3rem 0;
  padding-bottom: 3rem;
}

.modules-section-container {
  max-width: 1100px;
}
.modules-section .content {
  background-color: #f8f8f8;
  border-radius: 30px;
}
.modules-section .pos-content {
  padding: 2.5rem;
}
.modules-section .title {
  font-size: 30px;
  line-height: 100%;
  color: #21042e;
  margin-bottom: 1rem;
  font-weight: 600;
}
.modules-section .subtitle {
  font-size: 20px;
  line-height: 100%;
  color: #bc68a4;
}
.modules-section .pos-img {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}
.modules-section .content-row {
  margin: 40px 0;
}

.module-card {
  margin-bottom: 30px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.module-card:hover {
  transform: translateY(-5px);
}

.card-content {
  padding: 20px;
}

.card-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 10px;
}

.card-text {
  color: #6c757d;
}


@media (max-width: 768px) {
  .main-menu, .action-button {
    display: none;
  }

  .mobile-menu {
    display: block;
  }

  .banner-title {
    font-size: 2rem;
  }

  .features-section, .modules-section, .faq-section {
    padding: 30px 0;
  }

  .partner-icon {
    width: 50px;
    margin: 10px;
  }

  .bottom-banner-section {
    text-align: center;
  }

  .bottom-banner-section .col-md-4 {
    text-align: center;
    margin-top: 20px;
  }

  .footer-section {
    text-align: center;
  }

  .social-icons {
    justify-content: center;
  }

  .footer-list {
    margin-top: 30px;
  }
}
</style>    


// WEBPACK FOOTER //
// src/views/uupayHome.vue